import styled from 'styled-components';
import { COLORS } from '@/theme';

export const StyledReceipt = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  padding: 0.75rem 0;
  border-bottom: 1px solid ${COLORS.GREY};

  &:last-child {
    border-bottom: none;
  }
`;

export const StyledRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  font-size: 0.875rem;
`;

export const StyledStatusBadge = styled.span<{ $bg: string }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.25rem 0.75rem;
  border-radius: 999px;
  font-size: 0.8125rem;
  font-weight: 600;
  line-height: 1.4;
  white-space: nowrap;
  color: ${COLORS.WHITE};
  background-color: ${({ $bg }) => $bg};
`;

export const StyledLabel = styled.span`
  color: ${COLORS.GREY};
`;

export const StyledValue = styled.span`
  color: ${COLORS.BLACK};
  word-break: break-word;
`;

export const StyledLink = styled.a`
  color: ${COLORS.BLACK};
  text-decoration: underline;
  font-size: 0.875rem;
`;

export const StyledError = styled.div`
  color: ${COLORS.BLACK};
  font-size: 0.8125rem;
  word-break: break-word;
  opacity: 0.75;
`;

export const StyledEmpty = styled.div`
  color: ${COLORS.GREY};
  font-size: 0.875rem;
`;
